var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSlackinline = function SvgSlackinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E01E5A",
    d: "M6.35 17.675a2.665 2.665 0 1 1-2.665-2.665H6.35zM7.68 17.675a2.665 2.665 0 0 1 5.33 0v6.66a2.665 2.665 0 1 1-5.33 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#36C5F0",
    d: "M10.345 6.33a2.665 2.665 0 1 1 2.664-2.665V6.33zM10.344 7.68a2.665 2.665 0 0 1 0 5.33h-6.68a2.665 2.665 0 0 1 0-5.33z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2EB67D",
    d: "M21.652 10.345a2.665 2.665 0 1 1 2.665 2.665h-2.665zM20.32 10.344a2.666 2.666 0 0 1-5.329 0v-6.68a2.665 2.665 0 0 1 5.33 0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECB22E",
    d: "M17.656 21.67a2.665 2.665 0 1 1-2.665 2.665V21.67zM17.655 20.34a2.665 2.665 0 1 1 0-5.33h6.68a2.665 2.665 0 1 1 0 5.33z"
  })));
};
export default SvgSlackinline;